/* eslint-disable */
import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";

/*import url and gateway methods */
import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

//import membership options from json
import challengeMembershipStatusOption from "data/Prod/MembershipStatus.json";
import { useTranslation } from "react-i18next";
import { reactSelectStyle } from "Config/Config";

const AddNewMemberModal = ({
  roleList,
  afterCloseModal,
  setShowAlert = () => {},
  setAlertMessage = () => {},
  setMessageType = () => {},
}) => {
  const params = useParams();
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const token = localStorage.getItem("token");
  const { t } = useTranslation(); //for translation
  const [userInput, setUserInput] = useState("");
  const [userOptions, setuserOptions] = useState([]);
  const [userValue, setUserValue] = useState(null);
  const [userId, setUserId] = useState(null);
  const [userEmail, setUserEmail] = useState("");
  const [roleValue, setRoleValue] = useState(null);
  const [roleData, setRoleData] = useState(null);
  const [memberShipStatusValue, setMemberShipStatusValue] = useState(null);
  const [memberShipData, setmemberShipData] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [errors, setErrors] = useState({});

  const [isAdding, setIsAdding] = useState(false);

  //** Function for Validation */
  const validateForm = () => {
    const newErrors = {};
    const mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

    // Case 1: User must be selected.
    if (!userValue || userEmail === "") {
      newErrors.user = t("Please select or invite a user by name or email.");
    }

    // Case 2: User email field must not be empty.
    // Run further checks only if an email is provided
    if (userEmail !== "" && !userEmail.match(mailformat)) {
      newErrors.userEmailIsNotValid = t("Invalid email format") + " !";
    }

    // Case 4: User cannot add themselves.
    if (userInfo.email === userEmail) {
      newErrors.userEmailExists =
        t("You cannot add yourself as a member.") + " !";
    }

    // Role validation
    if (!roleValue) {
      newErrors.role = t("Please assign a role to this member.");
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  //function for get user details
  const getUserList = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_USERLIST_OPTIONS +
        `?token=${token}` +
        `&userstringinput=${userInput}`;

      const response = await getData(requestUrl);

      if (response.status) {
        if (response.data.length > 0) {
          setuserOptions(response.data);
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for get user input
  const userInputHandler = (val) => {
    setErrorMessage("");
    setUserInput(val);
  };

  //function user Selection
  const userSelectionHandler = (val) => {
    setErrorMessage("");
    if (val) {
      setUserValue(val);
      val._id ? setUserId(val._id) : setUserId(null); // if new user or other than contact user email is added
      val.email ? setUserEmail(val.email) : setUserEmail(val.value); // if new user or other than contact, set value as email
    } else {
      setUserValue(null);
      setUserId(null);
      setUserEmail("");
      setuserOptions([]);
    }

    // Clear all user-related errors on change
    if (errors.user || errors.userEmailExists || errors.userEmailIsNotValid) {
      setErrors((prev) => ({
        ...prev,
        user: "",
        userEmailExists: "",
        userEmailIsNotValid: "",
      }));
    }
  };

  //function for select role
  const roleSelectionHandler = (val) => {
    if (val) {
      setRoleValue(val);
      setRoleData(val.value);
      setErrorMessage("");
    } else {
      setRoleValue(null);
      setRoleData(null);
    }

    if (errors.role) {
      setErrors((prev) => ({ ...prev, role: "" }));
    }
  };
  //function for select memebership status
  const memberShipStatusSelectionHandler = (val) => {
    if (val) {
      setMemberShipStatusValue(val);
      setmemberShipData(val.value);
      setErrorMessage("");
    } else {
      setMemberShipStatusValue(null);
      setmemberShipData(null);
    }
  };

  //function for add member
  const addMemberHandler = async () => {
    if (!validateForm()) {
      setMessageType("error");
      setAlertMessage("Please fill up the required fields");
      setErrorMessage(t("Please fill up the required fields"));
      return;
    }

    try {
      setIsAdding(true);
      let challengeMemberData = {
        user: userId,
        challenge: params.id ? params?.id : null,
        role: roleData,
        useremail: userEmail,
        moderatorstatus: memberShipData,
        memberstatus: "1",
      };

      console.log("challengeMemberData---->", challengeMemberData);

      let requestUrl =
        url.API_BASE_URL + url.API_ADD_NEW_JOB_MEMBER + `?token=${token}`;

      const response = await postData(requestUrl, challengeMemberData);

      setIsAdding(false);

      if (response.status) {
        resetHandler();

        //hide member modal
        let bootstrapModal = document.querySelector("#addChallengeMember");
        let modal = bootstrap.Modal.getInstance(bootstrapModal);
        modal.hide();

        //call member list api function
        afterCloseModal();
        setMessageType("success");
      } else {
        setErrorMessage(response.message);
        setMessageType("error");
      }
      setAlertMessage(response.message);
    } catch (error) {
      console.log(error.message);
    }

    setShowAlert(true);
  };

  //function for reset
  const resetHandler = () => {
    setUserValue(null);
    setuserOptions([]);
    setMemberShipStatusValue(null);
    setmemberShipData(null);
    setRoleData(null);
    setRoleValue(null);
    setUserInput("");
    setUserId(null);
    setUserEmail("");
    setErrorMessage("");
    setErrors({});

    for (let memberStatus of challengeMembershipStatusOption) {
      if (memberStatus.value === "1") {
        memberShipStatusSelectionHandler(memberStatus);
      }
    }
  };

  useEffect(() => {
    if (userInput.length > 2) {
      getUserList();
    }
  }, [userInput]);

  useEffect(() => {
    for (let memberStatus of challengeMembershipStatusOption) {
      if (memberStatus.value === "1") {
        memberShipStatusSelectionHandler(memberStatus);
      }
    }
  }, []);

  const optionsToShow = userOptions.length > 0 ? userOptions : [];

  // Custom styles for CreatableSelect (User) to show red border on error
  const userSelectCustomStyles = {
    control: (base) => ({
      ...base,
      borderColor:
        errors.user ||
        errors.userEmail ||
        errors.userEmailIsNotValid ||
        errors.userEmailExists
          ? "#dc3545"
          : "#ced4da",
      "&:hover": {
        borderColor:
          errors.user ||
          errors.userEmail ||
          errors.userEmailIsNotValid ||
          errors.userEmailExists
            ? "#dc3545"
            : "#ced4da",
      },
      borderRadius: "7px",
      padding: "3px",
      minHeight: "40px",
      boxShadow: "none",
    }),
  };

  // Custom styles for Select (Role) to show red border on error
  const roleSelectCustomStyles = {
    control: (base) => ({
      ...base,
      borderColor: errors.role ? "#dc3545" : "#ced4da",
      "&:hover": {
        borderColor: errors.role ? "#dc3545" : "#ced4da",
      },
      borderRadius: "7px",
      padding: "3px",
      minHeight: "40px",
      boxShadow: "none",
    }),
  };

  return (
    <div
      className="modal fade"
      id="addChallengeMember"
      tabIndex="-1"
      aria-labelledby="addMemberLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content bg-white border-0 rounded-15">
          <div className="modal-header bg-primary text-white p-4 pb-3 border-bottom border-gray-300">
            <div className="d-flex align-items-center gap-3">
              <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
                <span className="material-symbols-outlined text-primary fs-5 icon-md">
                  group
                </span>
              </div>
              <div>
                <h3
                  className="offcanvas-title fw-bold text-white mb-0"
                  id="addMemberLabel"
                >
                  {t("Add New Member")}
                </h3>
                <p className="text-white fs-sm mb-0">
                  {t("Invite new members to this challenge")}
                </p>
              </div>
            </div>
            <button
              type="button"
              className="btn-close p-1 bg-gray-200 rounded-circle shadow-sm border-0"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={resetHandler}
            ></button>
          </div>
          <div className="modal-body p-4">
            <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm">
              <form
                onSubmit={(e) => e.preventDefault()}
                className="d-flex flex-column h-100"
              >
                {/* ----- user select section start ----- */}
                <div className="form-group mb-4 flex-grow-1">
                  <label
                    htmlFor="memberName"
                    className="d-block fs-sm fw-semibold mb-2"
                  >
                    {t(
                      "Invite app users / guest (search by name or email to invite)"
                    )}
                  </label>

                  <CreatableSelect
                    isClearable
                    styles={userSelectCustomStyles}
                    className="w-100"
                    placeholder={t("Search by name or email to invite")}
                    options={optionsToShow}
                    value={userValue}
                    onChange={userSelectionHandler}
                    onInputChange={userInputHandler}
                  />
                  {errors.user && (
                    <div className="invalid-feedback d-block">
                      {errors.user}
                    </div>
                  )}
                  {errors.userEmailIsNotValid && (
                    <div className="invalid-feedback d-block">
                      {errors.userEmailIsNotValid}
                    </div>
                  )}
                  {errors.userEmailExists && (
                    <div className="invalid-feedback d-block">
                      {errors.userEmailExists}
                    </div>
                  )}
                </div>
                {/* ----- user select section end ----- */}

                {/* ----- role select section start ----- */}
                <div className="form-group mb-4">
                  <label
                    htmlFor="role"
                    className="d-block fs-sm fw-semibold mb-2"
                  >
                    {t("Role")}
                  </label>

                  <Select
                    isClearable
                    styles={roleSelectCustomStyles}
                    className="w-100"
                    placeholder={t("Assign a role to the member")}
                    options={roleList}
                    value={roleValue}
                    onChange={roleSelectionHandler}
                  />

                  {errors.role && (
                    <div className="invalid-feedback d-block">
                      {errors.role}
                    </div>
                  )}
                </div>
                {/* ----- role select section end ----- */}

                {/* ----- status select section start ----- */}
                {/* <div className="form-group mb-4">
                  <label
                    htmlFor="role"
                    className="d-block fs-sm fw-semibold mb-2"
                  >
                    {t("Membership Status")}
                  </label>

                  <Select
                    className="w-100"
                    styles={reactSelectStyle("3px", "6px", true, false)}
                    placeholder={t("Select status")}
                    options={challengeMembershipStatusOption}
                    value={memberShipStatusValue}
                    onChange={(val) => memberShipStatusSelectionHandler(val)}
                  />
                </div> */}
                {/* ----- status select section end ----- */}

                {/* ----- button section start ----- */}
                <div className="action d-flex justify-content-end pt-3 border-top mt-auto">
                  <button
                    type="button"
                    className="btn btn-primary d-flex align-items-center gap-2"
                    onClick={addMemberHandler}
                    disabled={isAdding ? true : false}
                    style={{
                      cursor: isAdding ? "not-allowed" : "pointer",
                    }}
                  >
                    <span className="material-symbols-outlined me-1">
                      person_add
                    </span>
                    {t("Add Member")}
                    {isAdding && (
                      <div
                        className="mx-2 spinner-border spinner-border-sm"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    )}
                  </button>
                </div>
                {/* ----- button section end ----- */}
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddNewMemberModal;
